import OpenAI from 'openai';
import { getSynthesis, updateSynthesis } from './supabaseService';

const openai = new OpenAI({
  apiKey: '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',
  dangerouslyAllowBrowser: true
});

export async function generateSynthesis(messages: string[], context: string, topic: string, sessionId: string) {
  try {
    // First check if synthesis already exists
    const existingSynthesis = await getSynthesis(sessionId);
    if (existingSynthesis) {
      return existingSynthesis;
    }

    // Generate new synthesis using Chat Completions API
    const response = await openai.chat.completions.create({
      model: 'gpt-4o',
      messages: [
        { 
          role: 'system', 
          content: `Rôle :

Tu es un médiateur virtuel spécialisé dans la résolution de conflits entre personnes.
Ton objectif est d'aider les utilisateurs à mieux se comprendre et à trouver ensemble des pistes d'apaisement.
Tu n'es pas un juge, tu n'attribues pas de torts, tu facilites uniquement la compréhension mutuelle.
Tu adoptes un ton calme, neutre, encourageant et profondément bienveillant.

Contexte :

Deux personnes ont exprimé leur ressenti par écrit (ou transcription vocale).
Leur objectif est d'obtenir une synthèse qui leur permette d'apaiser la situation.

Les types de relations possibles sont :
- Couple
- Amis
- Associés ou collègues
- Voisins

Ta mission :

1️⃣ Accueille les deux points de vue avec respect.
2️⃣ Identifie les éventuels points d'accord ou de convergence.
3️⃣ Expose les éventuelles incompréhensions ou désaccords de manière factuelle et apaisée.
4️⃣ Propose des pistes ou suggestions concrètes pour que les deux personnes puissent continuer à dialoguer de façon constructive.
5️⃣ Utilise un style chaleureux et simple, compréhensible par tous.
6️⃣ Ne donne jamais d'ordre ni de verdict.

Règles essentielles :
- Ne jamais prendre parti
- Ne jamais utiliser de tournure de jugement ("X a eu tort", "Y est responsable")
- Toujours inviter à la discussion ouverte
- Favoriser les formulations type "Je vous invite à…" ; "Vous pourriez envisager…" ; "Une piste possible serait…"`
        },
        {
          role: 'user',
          content: `Voici un conflit :
Contexte : ${context}
Sujet : ${topic}

Message 1 : ${messages[0]}
Message 2 : ${messages[1]}

Structure ta réponse ainsi :

Bonjour à vous deux, je vous remercie de m'avoir confié vos ressentis.

Voici ce que je comprends de vos échanges :

1️⃣ Points où vous semblez être en accord :
- ...

2️⃣ Points où vous semblez avoir des incompréhensions ou des ressentis différents :
- ...

3️⃣ Quelques pistes de réflexion pour avancer ensemble :
- ...

${context.toLowerCase().includes('associé') ? `4️⃣ Suggestions générales pour une relation professionnelle apaisée :
- Clarifier les attentes respectives
- Formaliser les accords par écrit
- Mettre en place des règles ou processus internes
- Envisager un accompagnement extérieur ou médiation professionnelle si besoin

Ces suggestions sont des pistes générales. La décision finale appartient aux personnes concernées.` : ''}

${context.toLowerCase().includes('voisin') ? `4️⃣ Rappels généraux et pistes pour améliorer la relation de voisinage :
[Inclure quelques rappels sur les principes de bon voisinage et les recours possibles, sans citer d'articles de loi]

Ces suggestions sont des pistes générales. La décision finale appartient aux personnes concernées.` : ''}

Je vous encourage à continuer à dialoguer avec bienveillance et à chercher des solutions ensemble.
Je suis là pour faciliter votre échange, pas pour trancher.
Prenez soin de vous.`
        }
      ],
      temperature: 0.7
    });

    const synthesisText = response.choices[0].message.content;
    
    // Store the synthesis in the database
    if (synthesisText) {
      await updateSynthesis(sessionId, synthesisText);
    }

    return synthesisText;
  } catch (error) {
    console.error('Error generating synthesis:', error);
    throw error;
  }
}